module.exports = __webpack_public_path__ + "media/7_2.abb64bb6.wav";